<template>
    <v-layout>
        <Loading :value="loading" ></Loading>

    <!-- MODAL MODIF INFO DE USER -->
    <v-dialog v-model="dialogFormEditUser" max-width="80%" :overlay="true" scrollable persistent>
    	<v-card>
      	<v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>
            <span >Modification des informations personnelles</span>
          </v-toolbar-title>
        	<v-spacer></v-spacer>
        	<v-btn icon @click.native="dialogFormEditUser = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>
    	  <v-card-text v-loading="loading" element-loading-text="En cours d'enregistrement ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
          <v-container fluid grid-list-md>
            <v-form v-model="valid" ref="formUser" lazy-validation id="formUser">
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <el-card class="box-card" style="background:#fff">
                      <div>
                        <v-flex xs12 sm4  class="text-xs-center">
                            <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="logoUser" alt="avatar"></v-avatar><br/>
                            <input name="photo" type="file" style="display:none" ref="fileLogo" accept="image/*" @change="onFileImageLogoPicked"/>
                            <v-btn color="primary" class="white--text" required @click.native="$refs.fileLogo.click()">Photo  <v-icon right dark>cloud_upload</v-icon></v-btn><br/>
                        </v-flex>
                      </div>
                    </el-card>
                  </div>
                </el-col>
                <el-col :span="18" >
                  <div class="grid-content" style="padding:3px">
                    <el-row>
                      <el-col>
                        <div class="grid-content bg-purple">
                          <el-card class="box-card" style="background:#fff">
                            <v-layout row justify>
                              <v-flex md4>
                                <v-text-field label="Matricule" name="matricule" v-model="formUser.matricule">
                                </v-text-field>
                              </v-flex>
                              <v-flex md4>
                                <v-text-field label="Nom et prénoms" name="nom" v-model="formUser.nom"  required>
                                </v-text-field>
                              </v-flex>
                              <v-flex md4>
                                <v-select label="Genre" name="sexe" v-bind:items="listCivilie" v-model="formUser.sexe" item-value="value" item-text="text" ></v-select>
                              </v-flex>
                              <v-flex md4 class="mt-3">
                                 <el-date-picker
                                    v-model="formUser.dateNaiss"
                                    id="dateNaiss"
                                    name="dateNaiss"
                                    value-format="dd-MM-yyyy"
                                    type="date"
                                    placeholder="Date de naissance"
                                    style="width: 100%"
                                  ></el-date-picker>
                              </v-flex>
                            </v-layout>
                            <v-layout row justify>
                              <v-flex md4>
                                <v-text-field label="Matricule CNPS" name="numCnps" v-model="formUser.numCnps" item-value="id" item-text="libelle" ></v-text-field>
                              </v-flex>
                              <v-flex md4>
                                <v-text-field label="Fonction occupé" name="fonction" v-model="formUser.fonction"></v-text-field>
                              </v-flex>
                               <v-flex md4>
                                <v-text-field name="phone" min="0" label="Contact" v-model="formUser.phone" :counter="10" hint="Exemple: 0900000055" persistent-hint required></v-text-field>
                              </v-flex>
                               <v-flex md4>
                                <v-text-field label="Adresse" name="adresse" v-model="formUser.adresse">
                                </v-text-field>
                              </v-flex>
                            </v-layout>
                             <v-layout row justify v-if="droitAcces.new_contrat_employe">
                              <v-flex md4>
                                <v-select  label="Type d'utilisateur" name="selectTypeUser" v-bind:items="typeUser" v-model="selectTypeUser"  item-value="value" item-text="text" ></v-select>
                              </v-flex>
                              <v-flex md4>
                                <v-select label="Services" name="serviceUser" v-bind:items="listeServices" v-model="selectServiceUser" item-value="id" item-text="libelle" ></v-select>
                              </v-flex>
                            </v-layout>
                          </el-card>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                  <br/>
                   <div class="grid-content bg-purple">
                      <v-flex xs12 class="text-xs-center">
                        NB: taille 95 x 300
                          <br/>
                            <img :src="signUser"  style="height: 95px; width:300px ;" alt="avatar">
                          <br/>
                          <input name="signature" type="file" style="display:none" ref="fileSign" accept="image/*" @change="onFileSignLogoPicked"/>
                          <v-btn color="primary" class="white--text" required @click.native="$refs.fileSign.click()">Signature  <v-icon right dark>cloud_upload</v-icon></v-btn><br/>
                      </v-flex>
                  </div>
                </el-col>

              </el-row>
            <v-flex md12 class="mr-1">
              <div class="text-xs-right">
                <v-btn @click="dialogFormEditUser = false" color="error" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                <v-btn icons color="blue" @click="submitForm" :disabled="!valid" dark>Enregistrer <v-icon right>save</v-icon></v-btn>
              </div>
            </v-flex>
            </v-form>
          </v-container>
    	  </v-card-text>
      	<div style="flex: 1 1 auto;"></div>
    	</v-card>
    </v-dialog>
    </v-layout>
</template>

<script>
    import Loading from '@/components/Loading';
    export default {
        props:{
            idEmploye: {
                type: Number
            },
            show: {
                type: Boolean,
                default: false
            }
        },
        components: {Loading},
        name: "formEditUser",
        data(){
            return{
                notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
                droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
                loading: false,
                fileLogo: "",
                fileSign: '',
                fileUser:'',
                photo: '',
                listeServices:[],
                  items: [
                    { value: false, photo: '', nom: '', login: '', fonction: '', contact: '48867578', action: '' }
                  ],
                menu: false,
                modal: false,
                menu2: false,
                date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
                valid: true,
                selectServiceUser:'',
                logoUser: "/static/avatar-conducteur.png",
                signUser: "/static/signature.jpg",
                listCivilie: [
                  { text: "Masculin", value: 1 },
                  { text: 'Feminin', value: 2 },
                ],
                typeUser: [
                    { text: "Membre de l'entreprise", value: 1 },
                    //{ text: 'Representant de zone', value: 2 },
                  ],
                selectTypeUser:'',
                dialogFormEditUser: false,
                formUser: {
                    nom:  "",
                    sexe: "Masculin",
                    phone:"",
                    genre:'',
                    dateNaiss: null,
                    civilite:"",
                    matricule:"",
                    numCnps:"",
                    fonction:"",
                    adresse:""
                },
                listeCivilite:[
                    {
                        libelle: "Celibataire",
                        id: 1
                    },
                    {
                        libelle: "Marié",
                        id: 2
                    },
                    {
                        libelle: "Conjoint de fait",
                        id: 3
                    },
                    {
                        libelle: "Partenariat domestique",
                        id: 4
                    }
                ]
            }
        },
        watch:{
            show: function(newValue, oldValue){
                if(newValue == true){
                    this.dialogFormEditUser = true;
                    this.loadService()
                    this.loadInfoEmploye()
                }
                else{
                    this.dialogFormEditUser = false
                }
            }
        },
        methods:{
            successNotif(mess = ""){
                this.$notify({
                    title: 'ENREGISTREMENT REUSSI',
                    message: mess,
                    type: 'success',
                    position: 'top-center'
                })
            },
           //enregistrement des images
            onFileImageLogoPicked(event)
            {
                const files = event.target.files
                let filename = files[0].name
                if (filename.lastIndexOf(".") <= 0)
                {
                    return alert("Veuillez selectionner un  format de fichier valide ")
                }
                const fileReader = new FileReader()
                fileReader.addEventListener("load", () => {
                    this.logoUser = fileReader.result
                })
                fileReader.readAsDataURL(files[0])
                this.logoUser = files[0]
            },
            onFileSignLogoPicked(event) {
              const files = event.target.files
                let filename = files[0].name
                if (filename.lastIndexOf(".") <= 0)
                {
                    return alert("Veuillez selectionner un  format de fichier valide ")
                }
                const fileReader = new FileReader()
                fileReader.addEventListener("load", () => {
                    this.signUser = fileReader.result
                })
                fileReader.readAsDataURL(files[0])
                this.signUser = files[0]
            },
            loadService(){
                let url = this.domaine+"userCreate/liste/service";
                this.loading = true;
                this.$http.get(url).then(resp =>{
                    this.loading = false;
                    this.listeServices = resp.body.listeServices;

                }, error =>{
                    this.loading = false;
                    this.$message.error("Echec lors du chargement de la liste des services")
                });
            },
            submitForm(){
                this.loading = true;
                let url = this.domaine+"userCreate/users/"+this.idEmploye+"/update";
                var form = document.getElementById('formUser')
                var formdata = new FormData(form)
                formdata.append('type', this.selectTypeUser)
                formdata.append('service', this.selectServiceUser)
                this.$http.post(url,formdata).then(resp =>{
                    this.loading = false;
                    this.successNotif(resp.body.message)
                    this.closeForm()
                }, error=>{
                    this.loading = false
                    this.$message.error("Echec lors de l'enregistrement des informations utilisateurs")
                });
            },
            loadInfoEmploye(){
                this.loading = true;
                console.log("loadInfo");
                let url = this.domaine+"userCreate/infoUser/"+this.idEmploye
                this.$http.get(url).then(resp => {
                    console.log("detail conge employe",resp.body.employe)
                    let infoEmploye = resp.body.employe;
                    this.formUser = {
                        nom:  infoEmploye.nom,
                        sexe: infoEmploye.sexe,
                        dateNaiss: infoEmploye.dateNaissanceFormat,
                        phone: infoEmploye.contact,
                        civilite: infoEmploye.idCivilite,
                        matricule: infoEmploye.matricule,
                        numCnps: infoEmploye.matriculeCnps,
                        fonction: infoEmploye.fonction,
                        adresse: infoEmploye.adresse,
                        service: infoEmploye.service,
                        numCnps: infoEmploye.matriculeCnps
                    };
                    this.selectTypeUser = infoEmploye.service
                    this.selectServiceUser = infoEmploye.service
                    this.logoUser = infoEmploye.urlAvatar;
                    this.signUser =  infoEmploye.urlSign;
                    console.log("detail infoEmploye.urlAvatar",infoEmploye.urlAvatar)
                    this.loading = false;
                }, error =>{
                    this.loading = false
                    this.$message.error("Echec lors du chargement des informations utilisateurs")
                })
            },
            closeForm(){
                this.$emit("close");
            }
        },

    }
</script>

<style scoped>
    .el-form-item__content {
        width: 70%;
    }
</style>



// WEBPACK FOOTER //
// src/components/resourceHumaine/form_edit_user.vue